import React from 'react';
type TabItemProps = {
  isActive: boolean;
  onClick: (...args: any[]) => any;
  label: string;
  field: string;
};
const TabItem: React.SFC<TabItemProps> = props => {
  const { isActive, label, field } = props;
  let defaultBtnClass = 'btn';
  if (isActive) {
    defaultBtnClass = 'bg-color--black-light color--white';
  }
  function handleClick() {
    props.onClick(field);
  }
  return (
    <a className={`${defaultBtnClass} ph pv- bo-rad--0`} onClick={handleClick}>
      {label}
    </a>
  );
};
export default TabItem;
